import {NgModule} from '@angular/core';
import {FileSliderItemsComponent} from './item';
import {NgIf} from '@angular/common';
import {FileSliderComponentModule} from '../file-slider/item.module';
import {FileItemsComponentModule} from '../file-items/item.module';

@NgModule({
  imports: [
    NgIf,
    FileSliderComponentModule,
    FileItemsComponentModule,
  ],
  exports: [
    FileSliderItemsComponent
  ],
  declarations: [FileSliderItemsComponent],
  providers: [],
})
export class FileSliderItemsComponentModule {
}
